
import React, { createContext, useState, useContext, useEffect } from "react";
import { auth, db } from "../firebase/firebase";
import { signInWithEmailAndPassword, browserSessionPersistence, browserLocalPersistence, signOut, onAuthStateChanged, setPersistence } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const login = async (email, password, rememberMe) => {
    try {
      const persistence = rememberMe
        ? browserLocalPersistence
        : browserSessionPersistence;
      await setPersistence(auth, persistence);

      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password,
      );

      const docRef = doc(db, "utilizatori", email.toLowerCase());
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        return { ...userCredential.user, ...docSnap.data() };
      } else {
        throw new Error(
          "Contul de autentificare există, dar nu are un profil creat în Firestore de către administrator.",
        );
      }
    } catch (error) {
      console.error("Eroare la autentificare:", error);
      throw error;
    }
  };

  const logout = () => signOut(auth);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        const docRef = doc(db, "utilizatori", firebaseUser.email.toLowerCase());
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setUser({ ...firebaseUser, ...docSnap.data() });
        }
      } else {
        setUser(null);
      }
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
